import { MODELS, PROVIDER_COLORS_CSS } from '../data/models';
import { PROVIDERS } from '../data/providers';
import { state } from './state';
import { t } from './i18n';
import { escapeHtml } from './ui-helpers';

export function renderSelectedPills() {
  const wrap = document.getElementById("selected-pills");
  wrap.innerHTML = "";
  if (state.selectedModels.size === 0) {
    wrap.setAttribute("data-empty", t("picker.empty"));
    return;
  }
  wrap.removeAttribute("data-empty");
  MODELS.filter(m => state.selectedModels.has(m.id)).forEach(m => {
    const provider = PROVIDERS[m.provider];
    const pill = document.createElement("button");
    pill.className = "selected-pill";
    pill.title = "Remove";
    pill.innerHTML = `
      <span class="pill-dot" style="background:${PROVIDER_COLORS_CSS[m.provider]};color:${PROVIDER_COLORS_CSS[m.provider]}"></span>
      ${escapeHtml(m.label)}
      <span class="pill-x">×</span>
    `;
    pill.addEventListener("click", () => {
      state.selectedModels.delete(m.id);
      localStorage.setItem("lp_aiboard_selected", JSON.stringify([...state.selectedModels]));
      // Dispatch event so other modules update (picker-meta, run button, constellation)
      window.dispatchEvent(new CustomEvent("lp-selection-changed", { detail: { modelId: m.id, removed: true } }));
    });
    wrap.appendChild(pill);
  });
}

export function updatePickerMeta() {
  const n = state.selectedModels.size;
  document.getElementById("picker-meta").textContent =
    n === 0 ? t("picker.empty") : `${n} ${t("picker.selected")}`;
  const summaryEl = document.getElementById("selected-summary");
  if (summaryEl) {
    summaryEl.textContent = n === 0
      ? t("prompt.no_models")
      : `${n} ${n === 1 ? t("prompt.model") : t("prompt.models")}`;
  }
}
